import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import Button from "@/components/ui/Button";
import TwoFactorCard from "@/components/dashboard/TwoFactorCard";
import { useAuth, homeForRole } from "@/context/AuthContext";

// Standalone two-factor enrolment, mounted at /security/2fa.
//
// The same card is on every role's Settings → Security tab; this page exists so
// there is one direct link that works for any role, which is what the SuperAdmin
// nav uses (every other entry in that nav sits under /admin). Nothing redirects
// here — 2FA is opt-in, so no one is ever sent to this page against their will.
export default function TwoFactorSetup() {
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();
  const [justEnabled, setJustEnabled] = useState(false);

  const home = homeForRole(user?.role || "tester");
  const done = justEnabled || !!user?.twofa_enabled;

  // Refresh the cached profile so `twofa_enabled` is current for anything else
  // that reads it.
  async function onEnabled() {
    setJustEnabled(true);
    await refreshUser();
  }

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10 dark:bg-ink-950">
      <div className="mx-auto w-full max-w-2xl space-y-6">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900 dark:text-white">
            <ShieldCheck size={22} className="text-brand-500" /> Two-factor authentication
          </h1>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Signed in as {user?.email || "your account"}.
          </p>
        </div>

        <TwoFactorCard onEnabled={onEnabled} />

        <div className="flex flex-wrap items-center gap-3">
          {done ? (
            <Button type="button" onClick={() => navigate(home, { replace: true })}>
              Continue <ArrowRight size={16} />
            </Button>
          ) : (
            <Link to={home} className="text-sm font-medium text-slate-500 hover:text-slate-700 dark:text-slate-400">
              ← Back to the dashboard
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
